// extracted by mini-css-extract-plugin
export default {"date":"OrderDate_date__w+Mkb"};